export enum WizardStep {
  OFFER_SELECTION = 'offer-selection',
  RPPS_VERIFICATION = 'rpps-verification',
  CUSTOM_OFFER_DETAILS = 'custom-offer-details',
  ACCOUNT_CREATION = 'account-creation',
}

export const WIZARD_STEPS = [
  {
    id: WizardStep.OFFER_SELECTION,
    labelKey: 'steps.offerSelection',
  },
  {
    id: WizardStep.RPPS_VERIFICATION,
    labelKey: 'steps.rppsVerification',
  },
  {
    id: WizardStep.ACCOUNT_CREATION,
    labelKey: 'steps.accountCreation',
  },
] as const

export enum SubscriptionInterval {
  MONTHLY = 'monthly',
  YEARLY = 'yearly',
}

export const SUBSCRIPTION_INTERVAL_TRANSLATION_KEYS = {
  [SubscriptionInterval.MONTHLY]: 'pricing.month',
  [SubscriptionInterval.YEARLY]: 'pricing.year',
} as const

export enum OfferType {
  INTERN = 'intern',
  PRACTITIONER = 'practitioner',
  MEMBER = 'member',
}

const SUBSCRIPTION_MONTHS_COUNT = 12

export const SUBSCRIPTION_OFFERS = [
  {
    id: OfferType.INTERN,
    labelKey: 'offers.intern.label',
    descriptionKey: 'offers.intern.description',
    monthlyPrice: 40,
    yearlyPrice: 40 * SUBSCRIPTION_MONTHS_COUNT,
    color: 'orange',
  },
  {
    id: OfferType.PRACTITIONER,
    labelKey: 'offers.practitioner.label',
    descriptionKey: 'offers.practitioner.description',
    monthlyPrice: 50,
    yearlyPrice: 50 * SUBSCRIPTION_MONTHS_COUNT,
    color: 'blue',
  },
  {
    id: OfferType.MEMBER,
    labelKey: 'offers.member.label',
    descriptionKey: 'offers.member.description',
    monthlyPrice: 20,
    yearlyPrice: 20 * SUBSCRIPTION_MONTHS_COUNT,
    color: 'green',
  },
] as const
